import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '../Icon';
import styles from './Breadcrumb.module.css';
export const Breadcrumb = ({ items, className = '', style }) => {
    const getItemClassName = (index, isLast) => {
        const baseClass = styles.breadcrumbItem;
        if (isLast) {
            return `${baseClass} ${styles.current}`;
        }
        else if (index === 0) {
            return `${baseClass} ${styles.initial}`;
        }
        else {
            return `${baseClass} ${styles.intermediate}`;
        }
    };
    const getSeparatorClassName = (index) => {
        const baseClass = styles.separator;
        if (index === 0) {
            return `${baseClass} ${styles.initial}`;
        }
        else {
            return `${baseClass} ${styles.intermediate}`;
        }
    };
    const renderItem = (item, index, isLast) => {
        const itemClassName = getItemClassName(index, isLast);
        if (isLast || (!item.href && !item.onClick)) {
            return _jsx("span", { className: itemClassName, children: item.label });
        }
        if (item.href) {
            return (_jsx("a", { href: item.href, className: itemClassName, onClick: item.onClick, children: item.label }));
        }
        if (item.onClick) {
            return (_jsx("button", { type: 'button', className: itemClassName, onClick: item.onClick, children: item.label }));
        }
        return _jsx("span", { className: itemClassName, children: item.label });
    };
    return (_jsx("nav", { className: `${styles.breadcrumb} ${className}`, style: style, "aria-label": 'Breadcrumb', children: items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (_jsx(React.Fragment, { children: _jsxs("div", { className: styles.itemWrapper, children: [renderItem(item, index, isLast), !isLast && _jsx(Icon, { name: 'arrowChevronRight', alt: '', className: getSeparatorClassName(index) })] }) }, `${item.label}-${index}`));
        }) }));
};
